import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, NativeSelect } from "@/components/common";
import { api, errMsg, UNITS, VAT_RATES } from "@/lib/api";

const EMPTY = { name: "", code: "", category: "", unit: "Adet", vat_rate: 20, purchase_price: 0, sale_price: 0, min_stock: 0, opening_stock: 0 };

export default function ProductDialog({ open, onOpenChange, initial, onSaved }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) setF(initial ? { ...EMPTY, ...initial } : EMPTY);
  }, [open, initial]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = { ...f };
      ["vat_rate", "purchase_price", "sale_price", "min_stock", "opening_stock"].forEach((k) => { body[k] = Number(body[k]) || 0; });
      const { data } = initial ? await api.put(`/products/${initial.id}`, body) : await api.post("/products", body);
      toast.success(initial ? "Ürün güncellendi" : "Ürün oluşturuldu");
      onOpenChange(false);
      onSaved?.(data);
    } catch (e2) {
      toast.error(errMsg(e2));
    }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl rounded-[4px]" data-testid="product-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">{initial ? "Ürün Düzenle" : "Yeni Ürün / Stok Kartı"}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <Field label="Ürün Adı *" className="sm:col-span-2"><Input required value={f.name} onChange={set("name")} data-testid="product-name-input" /></Field>
          <Field label="Stok Kodu"><Input value={f.code} onChange={set("code")} placeholder="Otomatik" data-testid="product-code-input" /></Field>
          <Field label="Kategori"><Input value={f.category} onChange={set("category")} data-testid="product-category-input" /></Field>
          <Field label="Birim">
            <NativeSelect value={f.unit} onChange={set("unit")} data-testid="product-unit-select">
              {UNITS.map((u) => <option key={u}>{u}</option>)}
            </NativeSelect>
          </Field>
          <Field label="KDV Oranı">
            <NativeSelect value={f.vat_rate} onChange={set("vat_rate")} data-testid="product-vat-select">
              {VAT_RATES.map((v) => <option key={v} value={v}>{v === 0 ? "KDV'siz (%0)" : `%${v}`}</option>)}
            </NativeSelect>
          </Field>
          <Field label="Alış Fiyatı (₺)"><Input type="number" step="0.01" min="0" value={f.purchase_price} onChange={set("purchase_price")} data-testid="product-purchase-price-input" /></Field>
          <Field label="Satış Fiyatı (₺)"><Input type="number" step="0.01" min="0" value={f.sale_price} onChange={set("sale_price")} data-testid="product-sale-price-input" /></Field>
          <Field label="Kritik Stok Seviyesi"><Input type="number" step="any" value={f.min_stock} onChange={set("min_stock")} data-testid="product-min-stock-input" /></Field>
          {!initial && (
            <Field label="Açılış Stoğu"><Input type="number" step="any" value={f.opening_stock} onChange={set("opening_stock")} data-testid="product-opening-stock-input" /></Field>
          )}
          <DialogFooter className="sm:col-span-3">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="product-cancel-button">Vazgeç</Button>
            <Button type="submit" disabled={busy} data-testid="product-save-button">Kaydet</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
